<!--
Author: TangChen
Date: 2018-02-26
Desc: 购买基金组件，由index.js 配置引入
-->
<template>
    <div class="comp-buy comp">
        <el-form
            v-show="!buySuccess"
            ref="fundInfo"
            :model="fundInfo"
            :rules="rules"
            label-width="260px"
            class="pwdForm"
            inline-message
            v-on:submit.native.prevent
        >
            <el-form-item label="基金名称：" class="form-text">
                <div v-cloak class="text-con">
                    {{ fund.fundname + "(" + fund.fundcode + ")" }}
                </div>
            </el-form-item>
            <el-form-item :label="buyTypeText + '费收取方式：'" prop="sharetype" class="form-text">
                <el-select
                    v-model="currentShareType"
                    :disabled="fund.sharetype !== '2' || priSubmitBtn"
                >
                    <el-option
                        v-for="item in shareTypeLists"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                </el-select>
                <el-tooltip placement="top">
                    <div slot="content">
                        前收费是在申购基金时收取申购费,
                        <br />
                        而后收费则是在申购时不收费，
                        <br />
                        在赎回时才收取手续费用。
                    </div>
                    <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                </el-tooltip>
                <div v-if="fund.sharetype === '1' || fundInfo.sharetype === '1'" class="color-999">
                    <span>
                        {{ addAdministration || "该产品为后收费产品，赎回时可能存在费用" }}
                    </span>
                    <span class="like-a ml30" v-on:click.prevent="gotoDetail(fund)">查看详情</span>
                </div>
            </el-form-item>
            <el-form-item
                v-if="payway1show || payway2show || payway3show"
                label="资金来源："
                prop="way"
                class="form-text"
            >
                <el-radio-group v-model="fundInfo.way" :disabled="priSubmitBtn">
                    <el-radio v-if="payway2show" label="2" name="sell">银行卡&nbsp;</el-radio>
                    <el-radio v-if="payway1show" label="1" name="sell">
                        {{ $const.getXJBParam("sname") }}优惠买基金&nbsp;
                    </el-radio>
                    <el-radio v-if="payway3show && $util.remitOpen()" label="3" name="sell">
                        汇款支付&nbsp;
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item
                label="扣款账号："
                prop="pay"
                style="position: relative"
                class="payway-list"
            >
                <el-select
                    v-if="bankLists[0] && bankLists[0].options && bankLists[0].options.length > 0"
                    v-model="fundInfo.transactionaccountid"
                    placeholder="请选择扣款账号"
                    :class="{
                        hasVal: bankInfo && bankInfo.label && fundInfo.pay != '',
                        'has-discount': selectedBankDiscountText
                    }"
                    :disabled="priSubmitBtn"
                    v-on:change="bankSel"
                >
                    <el-option-group
                        v-for="(group, index) in bankLists"
                        :key="index"
                        :label="group.label"
                        class="bank-sel"
                    >
                        <el-option
                            v-for="(item, itemIndex) in group.options"
                            :key="item.channelid + itemIndex"
                            :label="item.displayLabel || getBankOptionLabel(item)"
                            :value="item.transactionaccountid"
                        >
                            <span>{{ getBankBaseLabel(item) }}</span>
                            <span v-if="getDiscountText(item)" class="bank-discount">
                                {{ getDiscountText(item) }}
                            </span>
                        </el-option>
                    </el-option-group>
                </el-select>
                <div v-if="selectedBankDiscountText" class="selected-bank-display">
                    <span class="selected-bank-label">{{ selectedBankBaseLabel }}</span>
                    <span class="bank-discount selected-bank-discount">
                        {{ selectedBankDiscountText }}
                    </span>
                </div>

                <div
                    v-if="bankLists[0] && bankLists[0].options && bankLists[0].options.length > 0"
                    class="hot-area"
                    v-on:click="openDialog"
                ></div>

                <template v-else>
                    <template v-if="fundInfo.way != 1 && $util.getBusinessModule('0A3')">
                        <div class="no-card-hot-area">
                            您还未添加银行卡，请立即
                            <span class="link-text" v-on:click.prevent="goAddBank">前往添加</span>
                        </div>
                        <span class="add-bank-btn add-bank-pos" v-on:click.prevent="goAddBank">
                            添加银行卡
                        </span>
                    </template>
                    <template v-else>
                        <div class="no-card-hot-area">
                            您的现金宝还未充值，请立即
                            <span
                                class="link-text"
                                v-on:click.prevent="
                                    $router.push({
                                        name: 'currencycharge'
                                    })
                                "
                            >
                                前往充值
                            </span>
                        </div>
                    </template>
                </template>
            </el-form-item>
            <el-form-item
                :label="buyTypeText + '金额：'"
                prop="amount"
                class="form-text"
                :show-message="!isXjbBalanceInsufficient"
            >
                <amount-input
                    v-model="fundInfo.amount"
                    :placeholder="$util.fmtNum(limit.min) + '元起'"
                    :disabled="priSubmitBtn"
                />
                <div class="quick-select">
                    <span
                        v-for="(item, index) in quickSelectList"
                        :key="index"
                        class="quick-chip"
                        :class="{ active: selectedQuickSelectName === item.name }"
                        v-on:click="quickSelect(item.name)"
                    >
                        {{ item.name }}
                    </span>
                </div>
                <!-- 现金宝余额不足时，保留表单错误红框，但用自定义文案承载“充值”跳转。 -->
                <p v-if="isXjbBalanceInsufficient" class="xjb-balance-error">
                    <i class="el-icon-circle-close" aria-hidden="true" />
                    <span>现金宝可用余额不足，去</span>
                    <span class="link-text" v-on:click.prevent="goToXjbCharge">充值</span>
                </p>
                <p v-else class="buy-range">
                    {{ buyTypeText }}范围 ({{ $util.fmtNum(limit.min) }}元-{{
                        $util.fmtNum(limit.max)
                    }}元)
                    <span v-if="curSelectCard.perdaymax">
                        , 单日累计限额{{ $util.fmtNum(curSelectCard.perdaymax) }}
                    </span>
                </p>
                <!-- <p v-if="!fund.comrate" class="redemp-prompt">
                    <i class="el-icon-warning" aria-hidden="true" /><span
                        v-if="false"
                        class="red"
                    >购买金额以10的倍数递增，</span><span>{{ fund.fundtype ===
                        '2'?'货币基金零费率':('买入费率' + fund.feerate) }}</span><span v-if="fund.isBuy===''">{{ '，预计'
                        + $util.fmtDate(fund.cfmdate) }}确认份额</span>
                </p> -->
            </el-form-item>
            <el-form-item label="金额确认：">
                <span class="upper-amount">{{ $util.capitalRMB(fundInfo.amount) }}</span>
            </el-form-item>
            <el-form-item v-show="showEasyBuy">
                <div class="flex hcenter">
                    <img
                        v-if="isagreeeasybuy === '1'"
                        src="../../assets/img/circle-checked.png"
                        class="w20 h20 pointer"
                        v-on:click="isagreeeasybuy = '0'"
                    />
                    <img
                        v-if="isagreeeasybuy === '0'"
                        src="../../assets/img/circle-unchecked.png"
                        class="w20 h20 pointer"
                        v-on:click="isagreeeasybuy = '1'"
                    />
                    <div class="ml10">
                        省钱购（自动帮您用{{ $const.getXJBParam("sname") }}买基金，享0折优惠）
                    </div>
                    <el-tooltip placement="top">
                        <div slot="content">
                            省钱购是什么？
                            <br />
                            银行卡资金将先充值{{
                                $const.getXJBParam("name")
                            }}，后自动帮您买入目标基金
                            <br />
                            省钱购有什么好处？
                            <br />
                            购买基金费用可低至0折
                            <br />
                            什么产品支持省钱购？
                            <br />
                            除货币基金外和产品C类份额外，都支持使用省钱购买基金
                        </div>
                        <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                    </el-tooltip>
                </div>
            </el-form-item>
            <el-form-item
                v-show="feeGate.benchmarkrate || feeGate.benchmarkrate == 0"
                label="买入费率："
                class="form-text"
            >
                <span v-if="feeGate.benchmarkrate == feeGate.executionrate">
                    {{ $util.fmtToPercent(feeGate.benchmarkrate, 2) }}
                </span>
                <span v-if="feeGate.benchmarkrate != feeGate.executionrate" class="del-text">
                    {{ $util.fmtToPercent(feeGate.benchmarkrate, 2) }}
                </span>
                <span v-if="feeGate.benchmarkrate != feeGate.executionrate" class="red-ml4">
                    {{ $util.fmtToPercent(feeGate.executionrate, 2) }}
                </span>
            </el-form-item>
            <el-form-item
                v-show="feeGate.estimatedcost || feeGate.estimatedcost == 0"
                label="预估买入手续费："
                class="form-text"
            >
                <span class="red-text">
                    {{
                        fundInfo.way === "2" && isagreeeasybuy === "1"
                            ? "0.00"
                            : $util.fmtNum(feeGate.estimatedcost)
                    }}元
                </span>
                <span v-if="feeGate.costsavings > 0" class="gray-text">
                    省{{
                        fundInfo.way === "2" && isagreeeasybuy === "1"
                            ? "0.00"
                            : $util.fmtNum(feeGate.costsavings)
                    }}元
                </span>
                <span class="tip-small">(仅为预计金额，以基金公司确认为准)</span>
            </el-form-item>
            <el-form-item
                v-if="isPwdCheck && showpwd"
                label="交易密码："
                prop="pwd"
                :class="{ 'form-text': fund.sign }"
            >
                <el-input
                    v-model.trim="fundInfo.pwd"
                    type="password"
                    placeholder="请输入交易密码"
                    :maxlength="16"
                />
                <span class="redemp-btn" v-on:click.prevent="resetTPwd">
                    <span class="like-a">忘记密码？</span>
                </span>
            </el-form-item>
            <el-form-item v-if="fund.fundclass != '1'" class="ml-80">
                <div v-if="readFileInfoList.length !== 0" class="protocol-checkbox-group">
                    <div class="protocol-checkbox-label">
                        <input v-model="checkbox" type="checkbox" />
                        <span class="red-text-pad">我已阅读并同意:</span>
                    </div>
                    <ul>
                        <li v-for="(item, index) in readFileInfoList" :key="index">
                            <!--<a v-if="item.textaddress.startsWith('http')" v-on:click="getClick(index)" :href="item.textaddress"  style="text-decoration:none; color: red" target="_blank">《{{item.textname}}》</a>-->
                            <!--<span v-else v-on:click="showPdf(item.textaddress)">《{{item.textname}}》</span>-->
                            <a class="cursor-pointer" target="_blank" v-on:click="getClick(index)">
                                《{{ item.filename }}》
                            </a>
                        </li>
                    </ul>
                </div>
            </el-form-item>
            <el-form-item v-if="smauthorization != '1'" class="ml-80">
                <div v-if="agreementList.filename" class="protocol-checkbox-group">
                    <div class="protocol-checkbox-label">
                        <input v-model="checkAgreement" type="checkbox" />
                        <span class="red-text-pad">我已阅读并同意:</span>
                    </div>
                    <ul>
                        <li>
                            <a
                                class="cursor-pointer"
                                target="_blank"
                                v-on:click="openFile(agreementList.fileid)"
                            >
                                《{{ agreementList.filename }}》
                            </a>
                        </li>
                    </ul>
                </div>
            </el-form-item>
            <el-form-item v-if="fundInfo.way == '1' && tradeRestrictionsShow">
                <div class="ml-70">
                    <span class="c_E60012">
                        温馨提示：{{ $cache.getCompanyInfoParam("10102035") }}
                    </span>
                </div>
            </el-form-item>
            <el-form-item v-if="deadlinetime || postChargeDescribe" class="ml-70">
                <div class="deadlinetime-content">
                    <div>提示：</div>
                    <div v-if="deadlinetime" class="flex-start">
                        <span class="mr2">1.</span>
                        <span>
                            {{
                                "我们将24小时受理您的交易申请，您交易日的交易申请至" +
                                deadlinetime +
                                "截止，" +
                                deadlinetime +
                                "以后的交易申请或非交易日的交易申请视为于下一个交易日提交。"
                            }}
                        </span>
                    </div>
                    <div v-if="postChargeDescribe" class="add-administration flex-start">
                        <span class="mr2">{{ deadlinetime ? "2." : "1." }}</span>
                        <span>{{ postChargeDescribe }}</span>
                    </div>
                </div>
            </el-form-item>
            <el-form-item>
                <div style="width: 50%">
                    <el-button class="dc-cancel-btn" v-on:click="$router.back()">上一步</el-button>
                    <el-button
                        v-if="!priSubmitBtn"
                        type="primary"
                        class="medium"
                        :disabled="hasProductOverview || time > 0 || checkBuy == false"
                        v-on:click="submitInfoBefore"
                    >
                        确定
                        <span id="time"></span>
                    </el-button>
                    <el-button
                        v-if="priSubmitBtn"
                        type="primary"
                        class="medium"
                        v-on:click="submitInfo('fundInfo')"
                    >
                        确定
                    </el-button>
                </div>
            </el-form-item>

            <select-bank
                :dialog-bank-lists="dialogBankLists"
                :select-bank-show="cardsDialog"
                :buy-type-text="buyTypeText"
                :way="fundInfo.way"
                :is-buy="true"
                :show-discount="true"
                v-on:select-bank-close="handleClose"
                v-on:select-bank-info="selectCurCard"
            ></select-bank>
            <el-dialog title="下单确认" :visible.sync="confirmDialog" width="580px">
                <div class="confirm-container confirm-order-text">
                    交易日{{ deadlinetime }}以后提交申请，交易申请将顺延至下一交易日发起。
                </div>
                <div class="button-container confirm-btn">
                    <div class="btn-confirm cancel" v-on:click="confirmDialog = false">取消</div>
                    <div class="btn-confirm" v-on:click="signContract()">确定</div>
                </div>
            </el-dialog>
            <el-dialog
                :title="buyTypeText + '结果'"
                :visible.sync="resultDialog"
                class="prop"
                width="580px"
                :close-on-click-modal="false"
                :show-close="false"
            >
                <div class="result-container">
                    <img src="@/assets/img/buy_success.png" alt="" srcset="" />
                    <div class="buy-suc">
                        {{ buyTypeText }}买入成功！
                        <span v-if="fundInfo.way == '2' && payStatus != ''">
                            {{ payStatus }}
                        </span>
                    </div>
                    <div v-if="resultDialogObj.operdatetime" class="buy-suc-time">
                        {{ formatDateTime(resultDialogObj.operdatetime) }}
                    </div>
                    <!-- 购买募集期产品提示 -->
                    <div v-if="fund.status === '1'" class="buy-suc-tip">请留意基金合同生效公告</div>
                </div>
                <div class="success-time">
                    <div
                        class="time-item"
                        :class="{ 'single-item': !resultDialogObj.incomeqrydate }"
                    >
                        <div class="progress-dot">
                            <div class="red-line"></div>
                            <div class="red-circle"></div>
                            <div class="red-line"></div>
                        </div>
                        <div class="time-text">
                            <p>预计{{ $util.fmtDate(resultDialogObj.transactioncfmdate) }}</p>
                            <p>确认份额</p>
                        </div>
                    </div>
                    <div v-if="resultDialogObj.incomeqrydate" class="time-item">
                        <div class="progress-dot">
                            <div class="red-line"></div>
                            <div class="red-circle"></div>
                            <div class="red-line"></div>
                        </div>
                        <div class="time-text">
                            <p>预计{{ $util.fmtDate(resultDialogObj.incomeqrydate) }}</p>
                            <p>查看收益</p>
                        </div>
                    </div>
                </div>
                <div class="button-container confirm-btn">
                    <div class="btn-confirm" v-on:click="sucClick">确定</div>
                </div>
            </el-dialog>
        </el-form>
        <pdf-popup
            base64
            :visible="pdfVisible"
            :need-time="needTime"
            :read-file-info-list="currentFileInfoList"
            :show-close="true"
            v-on:close="finishReading"
            v-on:cancel="cancelReading"
        ></pdf-popup>
        <img-code :dialog-visible="dialogVisible" v-on:verify-in="getVerifyCode" />
        <fund-protocol
            v-if="!buySuccess"
            ref="protocol"
            v-model="protocol"
            :fund="fund"
            :show-proto-arr="false"
            v-on:all-read="smsCheck"
        />
        <verifycode-check
            :dialog-visible="checkMobile"
            :mobile="bankInfo.mobile"
            v-on:verify-in="checkVerifyCode"
        />
        <result
            v-if="buySuccess"
            :active="2"
            :result="result"
            v-on:return-page="reset"
            v-on:return-login="$router.push({ name: 'traderecord' })"
        />
        <smsValid
            :mobileno="$cache.getUser().mobileno"
            :en-mobileno="$cache.getUser().en_mobileno"
            :dialog-visible="smsVisible"
            sms-type="2"
            :show-remote="false"
            close
            v-on:close="smsClose"
            v-on:sms-comfirm="buyNow(true)"
        />
        <buy-risk-dialog
            :visible.sync="buyRiskdialogVisible"
            :type="dialogType"
            :content="dialogContent"
            :button-text="dialogButtonText"
            v-on:confirm="handleDialogConfirm"
        />
        <fund-sdx-dialog
            :fund="sdxFundInfo"
            :sdx-dialog-visible="sdxDialogVisible"
            v-on:dialogClosed="sdxDialogClose"
            v-on:dialogContinue="sdxDialogContinue"
        />
        <sign-contract-dialog
            v-if="signContractdialogVisible"
            :visible.sync="signContractdialogVisible"
            :fund-info="fundInfo"
            :fund="fund"
            v-on:confirm="privateSubmitBefore"
        ></sign-contract-dialog>
    </div>
</template>
<script>
import format from "date-fns/format";
import result from "@/components/layout/result";
import fundProtocol from "@/components/form/fundProtocol";
import verifycodeCheck from "@/components/form/verifycodeCheck";
import imgCode from "@/components/layout/imgCode.vue";
import PdfPopup from "@/components/util/pdfPopup";
import fundApi from "@/api/fund";
import userApi from "@/api/user";
import selectBank from "@/components/layout/selectBank.vue";
import smsValid from "@/components/form/smsValid.vue";
import buyRiskDialog from "@/components/fund/buyRiskDialog.vue";
import signContractDialog from "@/components/fund/signContractDialog.vue";
import fundSdxDialog from "@/components/form/fundSdxDialog";
import commonApi from "@/api/common";
import { sceneEnum } from "@/util/util_jfit";
import AmountInput from "@/components/common/AmountInput.vue";

export default {
    name: "Buy",
    components: {
        AmountInput,
        PdfPopup,
        result,
        fundProtocol,
        verifycodeCheck,
        imgCode,
        selectBank,
        smsValid,
        buyRiskDialog,
        signContractDialog,
        fundSdxDialog
    },
    data() {
        return {
            xjbBankList: [],
            // 表单信息
            fundInfo: {
                amount: "",
                way: "",
                pay: "",
                sharetype: "",
                pwd: "",
                transactionaccountid: "",
                paycenterid: ""
            },
            allBank: [],
            dialogVisible: false,
            btnMsg: "获取短信验证码",
            time: 0, // 验证码再次发送间隔
            isPwdCheck: false, // 是否校验密码
            checkMobile: false, // 短信鉴权验证码显示开关
            pla: "请输入起购金额",
            buySuccess: false, // 购买状态
            result: {
                // 结果页面信息
                cla: "register-success",
                msg: "您的购买申请已提交成功！",
                btnMsg: "预计11月30日以11月29日净值确认份额，如遇节假日则顺延，请耐心等待",
                special: false,
                btnL: {
                    text: "继续购买",
                    event: "return-page"
                },
                btnR: {
                    text: "查看交易记录",
                    event: "return-login"
                },
                transfer: {
                    amount: "",
                    acct_name: "",
                    issuring_bank: "",
                    cnaps: "",
                    acct_no: "",
                    big_cnaps: "",
                    bank_exchange_no: ""
                }
            },
            query: null,
            xjbAll: "", // 现金宝总资产
            xjbInfo: [], // 现金宝信息
            fund: {}, // 基金信息获取
            protocol: false,
            bankLists: [], // 银行卡列表
            limit: { text: "起购金额范围为：", min: "0", max: "0" }, // 限额
            rules: {
                // 校验规则配置
                amount: [{ validator: this.amountLimit, trigger: "blur" }],
                pay: [{ validator: this.validatePayWay, trigger: "change" }],
                selectedBankid_card: [{ validator: this.validateCard, trigger: "change" }],
                pwd: [{ required: true, message: "请输入交易密码", trigger: "blur" }]
            },
            feeGate: {},
            xjbSel: {},
            bankInfo: {}, // 校验银行卡信息
            cfmdate: "", // 确认日期
            checkbox: false, // 阅读确认1
            checkTime: true, // 阅读确认2
            checkBuy: true,
            checkAgreement: false, // 阅读确认电子签名约定书
            readFileInfoList: [], // 披露文件信息
            readappno: "", // 申请单编号
            infoText: "",
            isReadFileReading: false,
            currentFileInfoList: [], // 当前阅读信批文件
            pdfVisible: false,
            needTime: false,
            hasReadProductOverview: false, // 是否已完整阅读产品概要

            hasBankRroute: false, // 是否开启智能路由
            bankListsOfR: [], // 不区分支付渠道的银行卡信息
            selectedBankid_card: "", // 智能路由下选择的银行卡
            hasAccount: false, // 是否有智能路由推荐渠道下的银行卡
            recChannelid: "", // 推荐的channelid
            recChannelname: "", // 推荐的渠道网点名
            timer: "",
            allBankList: [], // 快捷支付银行卡
            transBankList: [], // 汇款支付银行卡
            shareTypeLists: [
                {
                    value: "0",
                    label: "前收费"
                },
                {
                    value: "1",
                    label: "后收费"
                }
            ],
            selectShareType: "",
            buyTypeText: "",
            cardsDialog: false,
            confirmDialog: false,
            dialogBankLists: [],
            curSelectCard: {},
            resultDialog: false,
            resultDialogObj: {},
            saveMoneyFlag: false,
            isagreeeasybuy: "0",
            xjbFundCode: "",
            xjbFundCodeInfo: "",
            selectCurCardBefore: {},
            info: {},
            randomToken: "",
            payStatus: "",
            smsVisible: false,
            mrfflag: false,
            deadlinetime: "",
            payway1show: false,
            payway2show: false,
            payway3show: false,
            postChargeDescribe: "", // 附加管理费说明
            addAdministration: "", // 后收费说明
            tradeRestrictionsShow: false, // 节假日xx宝的提示
            buyRiskdialogVisible: false, // 弹窗显示状态
            dialogType: "", // 弹窗类型（forbid/warn）
            dialogContent: "", // 弹窗文案
            dialogButtonText: "", // 按钮文案
            oldercustRiskWarnPassed: false, // 高龄客户风险提示已确认
            signContractdialogVisible: false, // 签署合同弹窗显示状态
            contractList: [], // 待签署合同列表
            contractno: "",
            producttype: "", // 综合理财中对应的产品类型
            agreementList: {}, // 电子签名约定书
            smauthorization: "", // 1-已授权
            hasProductOverview: false, // 确定按钮
            showpwd: true, // 私募密码输入需后置 公募默认展示，私募签署合同后展示
            priSubmitBtn: false, // 私募购买输入密码时的确认按钮
            selectedQuickSelectName: "",
            sdxFundInfo: {},
            sdxDialogVisible: false,
            sdxGatePassed: false,
            pendingSdxAction: null,
            queryRateSeq: 0,
            xjbConvertRelationCache: {},
            xjbConvertRelationPending: {}
        };
    },
    computed: {
        // 10102053=1 时，交易密码输入处忘记密码也应进入手机号验证重置流程。
        resetTradePwdAuthMode() {
            const value = this.$cache.getCompanyInfoParam("10102053");
            return value === undefined || value === null || value === "" ? "0" : String(value);
        },
        isTradeSmsReset() {
            return this.resetTradePwdAuthMode === "1";
        },
        quickSelectList() {
            const val = this.$util.getParamValue("10113001");
            if (typeof val === "string") {
                try {
                    return JSON.parse(val);
                } catch (e) {
                    return [];
                }
            }
            return Array.isArray(val) ? val : [];
        },
        isXjbBalanceInsufficient() {
            // 只处理“已选现金宝账户，且现金宝可用余额低于本次起购额”的特殊提示。
            // 余额必须取现金宝账户返回的 xjbasset，不能用 limit.max 反推，否则会混入渠道上限。
            if (this.fundInfo.way != "1") {
                return false;
            }
            if (this.$util.isEmpty(this.fundInfo.transactionaccountid)) {
                return false;
            }
            const xjbMin = this.getXjbMinAmount(this.bankInfo);
            const xjbAsset = this.$util.isEmpty(this.bankInfo.xjbasset)
                ? null
                : Number(this.bankInfo.xjbasset);
            return xjbMin > 0 && xjbAsset !== null && !isNaN(xjbAsset) && xjbAsset < xjbMin;
        },
        useOldLogic() {
            // 汇款交易是否需要开通汇款渠道
            // 交易账号模式: paramid:10113006   1-单交易账号,2-多交易账号
            const tradeInfo = this.$cache.getParamValue("trade_info");
            const sysFlag = this.$cache.getSysParam("10113006");

            return (tradeInfo && tradeInfo.openremittancechannel) || sysFlag == "2";
        },
        showEasyBuy() {
            return (
                this.$util.getConfig().showSpecial &&
                this.fundInfo.way == "2" &&
                this.$util.xjbIsOpen() &&
                this.xjbFundCode != this.fund.fundcode &&
                !this.mrfflag
            );
        },
        currentShareType: {
            get() {
                return this.fund.sharetype === "2" ? this.fundInfo.sharetype : this.fund.sharetype;
            },
            set(val) {
                if (this.fund.sharetype === "2") {
                    this.fundInfo.sharetype = val;
                }
            }
        },
        selectedBankDiscountText() {
            if (!this.fundInfo.transactionaccountid) return "";
            return this.getDiscountText(this.bankInfo);
        },
        selectedBankBaseLabel() {
            if (!this.fundInfo.transactionaccountid) return "";
            return this.getSelectedBankBaseLabel(this.bankInfo);
        }
    },
    watch: {
        "fundInfo.amount"(val) {
            if (this.hasBankRroute && this.fundInfo.way === "2") {
                // 获取智能路由
                this.handleBankRroute();
                return;
            }
            this.isAmount(val);
        },
        "fundInfo.way"(val) {
            this.$refs["fundInfo"].clearValidate();
            this.fundInfo.pay = "";
            this.fundInfo.transactionaccountid = "";
            this.curIndex = "";
            this.selectCurCardBefore = {
                index: "",
                item: {}
            };
            this.curSelectCard = {};
            this.bankinfo = {};
            this.bankInfo = {}; // 清空银行卡信息
            this.$set(this.limit, "min", "0"); // 切换资金来源时重置 limit，等选卡后再设置
            this.$set(this.limit, "max", "0");
            let arr = [];
            if (val == "2") {
                arr = this.allBankList;
            } else if (val == "3") {
                // 当有此参数值时或者配置了交易账号模式才走原逻辑
                if (this.useOldLogic) {
                    arr = this.transBankList;
                } else {
                    const list = this.allBankList.map((item) => ({
                        ...item,
                        paycentername: "汇款",
                        discountforpurchase:
                            item.bankcardsignstatus == 1 ? "" : item.discountforpurchase
                    }));
                    arr = [...list, ...this.transBankList];
                }
            } else {
                arr = this.xjbBankList;
            }
            if (arr.length == 0) {
                this.bankLists = [];
            } else {
                // arr.unshift({
                //     value: "",
                //     bankAdd: "添加银行卡",
                //     bankCate: "",
                //     label: "添加银行卡"
                // });
            }
            let newObj = {
                label: "",
                options: arr
            };
            this.dialogBankLists = arr;

            this.bankLists.shift();
            this.bankLists.push(newObj);

            // 当只有一张银行卡时，默认选中。selectCurCard方法的执行需要this.bankLists存在值，故放在后面
            if (arr.length == 1) {
                this.selectCurCard(arr[0]);
            }

            this.feeGate = {};
        },
        "fundInfo.sharetype"(val) {
            if (val === "1") {
                this.feeGate = {};
            } else {
                this.queryRate();
            }
        },
        "fundInfo.pay"(val) {
            if (this.fundInfo.way === "1") {
                // selectCurCard 会先写 pay，再由 bankSel 补 transactionaccountid；
                // 这里按支付渠道和交易账号共同定位当前现金宝账户，保证与 bankSel 使用同一条数据。
                const _x = this.xjbBankList.find((item) => {
                    const samePay = item.channelid === val;
                    const sameAccount =
                        this.$util.isEmpty(this.fundInfo.transactionaccountid) ||
                        item.transactionaccountid === this.fundInfo.transactionaccountid;
                    return samePay && sameAccount;
                });
                if (_x) {
                    this.xjbSel = _x;
                    this.$set(this.limit, "min", this.getXjbMinAmount(_x));
                    this.$set(this.limit, "max", this.getXjbMaxAmount(_x));
                    this.pla =
                        this.$util.fmtNum(this.limit.min) +
                        "元起，最多可投" +
                        this.$util.fmtNum(this.limit.max) +
                        "元";
                    this.queryRate();
                }
                // 未匹配到当前现金宝账户时不清零 limit，由 bankSel 负责设置正确的 limit
            }
        },
        // readFileInfoList: {
        //     handler: function (obj) {
        //         if (
        //             obj.every(function (item) {
        //                 return item.read; // 产品概要强制阅读，其他不用
        //             })
        //         ) {
        //             this.checkbox = true;
        //             // this.checkTime = false;
        //         }
        //     },
        //     deep: true
        // },
        checkbox(val) {
            if (val) {
                // 如果已经完整阅读过产品概要，则不再弹出强制阅读
                if (this.hasReadProductOverview) {
                    return;
                }

                this.currentFileInfoList = [];
                this.readFileInfoList.forEach((item) => {
                    if (item.filetype == "7") {
                        this.currentFileInfoList.push(item);
                    }
                });
                if (this.currentFileInfoList.length > 0) {
                    this.needTime = true;
                    this.pdfVisible = true;
                }
            }
            if (!val) {
                this.readFileInfoList.forEach((item) => (item.read = false));
            }
        },
        selectedBankid_card(val) {
            if (this.fundInfo.way === "2") {
                this.handleBankRroute();
            }
        }
    },
    async mounted() {
        let xjbFundInfo = JSON.parse(sessionStorage.getItem("xjbFundInfo"));
        this.xjbFundCode = xjbFundInfo ? xjbFundInfo.fundcode : "";
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name) || "null") || {};
        if (!this.fund.fundcode) {
            this.$alert("交易上下文已失效，请从基金列表或详情重新进入", "提示", {
                confirmButtonText: "确定"
            }).then(() => {
                this.$router.replace({ name: "fund" });
            });
            return;
        }
        this.producttype = this.fund.producttype;

        // 查询公私募标识
        if (!this.fund.fundclass) {
            const res = await fundApi.getFundDetails({ fundcode: this.fund.fundcode });
            this.fund.fundclass = res.data && res.data[0] && res.data[0].fundclass;
        }

        this.showpwd = this.fund.fundclass != "1";

        // 查中港互认基金标识
        await this.getMrfFlag();

        if (this.fund.sharetype == "2") {
            this.rules.sharetype = [
                { required: true, message: "请选择收费方式", trigger: "change" }
            ];
        }
        this.buyTypeText = this.fund.status === "1" ? `认购` : `申购`;
        this.info = this.$cache.getUser();
        this.isagreeeasybuy = this.info.custtag || "0";
        if (this.xjbFundCode == this.fund.fundcode || this.mrfflag) {
            this.isagreeeasybuy = "0";
        }
        // 组合购买基金数据初始化
        if (this.fund.comrate) {
            this.initComboData();
        }
        this.isPwdCheck = this.$cache.getPwdCheck(this.fund.way);
        this.getBuyWay();
        this.getFileInfo();
        // this.qryBusinessFile(); // 查询电子签名约定书
        // 是否开启智能路由
        this.hasBRroute();
        this.$cache.getCompanyInfoParam("10102033") &&
            this.isInTimeRange(
                this.$cache.getCompanyInfoParam("10102033"),
                format(new Date(), "YYYYMMDDhhmmss")
            );
        this.$nextTick(() => {
            this.initTradeSdxAccess();
        });
    },
    methods: {
        goAddBank() {
            if (this.$util.checkAddBankBlocked()) return;
            this.$router.push({ name: "addbank" });
        },
        // 页面首次进入时尝试消费入口发放的一次性标志；没有标志则立即补前置适当性。
        initTradeSdxAccess() {
            if (!this.$util.isNeedSdxCheck(this.fund)) {
                this.sdxGatePassed = true;
                return;
            }
            this.sdxGatePassed = this.$util.consumeTradeSdxAccess(this.$route.name, this.fund);
            if (!this.sdxGatePassed) {
                this.ensureTradeSdxAccess();
            }
        },
        // 所有继续交易的动作都先经过这里，保证直达、取消重试都不会绕过适当性。
        ensureTradeSdxAccess(onPassed) {
            if (onPassed) {
                this.pendingSdxAction = onPassed;
            }
            if (!this.$util.isNeedSdxCheck(this.fund)) {
                this.sdxGatePassed = true;
                this.runPendingSdxAction();
                return true;
            }
            if (this.sdxGatePassed) {
                this.runPendingSdxAction();
                return true;
            }
            if (this.sdxDialogVisible) {
                return false;
            }
            this.$util.fundRiskCheck(this, this.fund, (res) => {
                if (res) {
                    this.$util.getSdxProtocol(res, (data) => {
                        if (data) {
                            this.sdxFundInfo = Object.assign({}, data, {
                                way: this.fund.way || this.fundInfo.way
                            });
                            this.sdxDialogVisible = true;
                        }
                    });
                }
            });
            return false;
        },
        goToXjbCharge() {
            this.$router.push({ name: "currencycharge" });
        },
        // 适当性通过后恢复被阻断的当前动作，避免用户重复点击下一步。
        runPendingSdxAction() {
            if (!this.pendingSdxAction) {
                return;
            }
            const pendingAction = this.pendingSdxAction;
            this.pendingSdxAction = null;
            pendingAction();
        },
        // 这里只保留原有“下一步后展示协议/支付确认”的流程，不处理准入判断。
        continueSubmitInfo() {
            if (this.bankInfo.paytype === "1" && this.fundInfo.way === "2") {
                this.dialogVisible = true;
            } else {
                this.$util.getSdxProtocol(this.fund, (res) => {
                    this.fund = res;
                    this.confirmDialog = false;
                    this.protocol = true;
                });
            }
        },
        // 适当性优先级最高；只有当前页已经放行后，才允许弹高龄提示和下单确认。
        continueSubmitInfoBefore() {
            // 开了高龄客户管理开关才用
            if (this.$util.buyVerificationOpen() && !this.oldercustRiskWarnPassed) {
                this.$util.checkComplianceService(this.fund.fundcode).then((checkRes) => {
                    if (checkRes.dialogType) {
                        this.dialogButtonText = checkRes.dialogButtonText;
                        this.dialogType = checkRes.dialogType;
                        this.dialogContent = checkRes.dialogContent;
                        this.buyRiskdialogVisible = true;
                    } else {
                        this.confirmDialog = true;
                    }
                });
            } else {
                this.confirmDialog = true;
            }
        },
        sdxDialogClose() {
            this.sdxDialogVisible = false;
        },
        // 进入页前置适当性通过后，只放行当前页面，不重新发入口标志。
        sdxDialogContinue() {
            this.sdxDialogVisible = false;
            this.sdxGatePassed = true;
            this.fund = Object.assign({}, this.fund, this.sdxFundInfo);
            this.runPendingSdxAction();
        },
        getDiscountText(item) {
            if (!item) return "";
            const rawDiscount = this.getPurchaseDiscount(item);
            const discount = String(rawDiscount).trim();
            if (!discount) return "";
            const numericDiscount = Number(discount);
            if (!Number.isNaN(numericDiscount)) {
                if (numericDiscount === -1) return "";
                if (numericDiscount === 1) return "不打折";
            }
            if (discount.indexOf("折") > -1) {
                const discountNum = Number(discount.replace("折", ""));
                if (!Number.isNaN(discountNum)) {
                    return `${this.formatDiscountText(discountNum)}折`;
                }
                return discount;
            }
            if (!Number.isNaN(numericDiscount)) {
                return `${this.formatDiscountText(numericDiscount * 10)}折`;
            }
            return discount;
        },
        formatDiscountText(discount) {
            return Number(discount.toFixed(3)).toString();
        },
        getPurchaseDiscount(item) {
            if (
                item.discountforpurchase !== undefined &&
                item.discountforpurchase !== null &&
                String(item.discountforpurchase).trim() !== ""
            ) {
                return item.discountforpurchase;
            }
            return this.fundInfo.way === "3"
                ? this.$cache.getCompanyInfoParam("24082301") || ""
                : "";
        },
        getBankBaseLabel(item) {
            if (!item) return "";
            const bankName = this.$cache.getDict("110080", item.bankcode);
            return `${item.paycentername}-${bankName}(${item.depositcard})`;
        },
        getSelectedBankBaseLabel(item) {
            if (!item) return "";
            const bankName = this.$cache.getDict("110080", item.bankcode);
            const depositcard = item.depositcard ? `****${String(item.depositcard).slice(-4)}` : "";
            return `${item.paycentername}-${bankName}(${depositcard})`;
        },
        getBankOptionLabel(item) {
            return this.getBankBaseLabel(item);
        },
        isInTimeRange(timeRange, currentTime) {
            const [start, end] = timeRange.split(",");
            this.tradeRestrictionsShow = currentTime >= start && currentTime <= end;
            return currentTime >= start && currentTime <= end;
        },
        // 是否开启智能路由
        hasBRroute(val) {
            this.hasBankRroute = sessionStorage.getItem("hasBankRroute", "0") != "0";
        },
        // 获取智能路由
        handleBankRroute() {},
        getLimit(channelid) {
            let channel = channelid === "3" ? "hk" : "bank";
            let min = this.$cache.getChannelLimit(channel, "min") || this.fund.min; // 中台配置渠道限额优先取中台配置
            let max = this.$cache.getChannelLimit(channel, "max") || this.fund.max;
            this.$set(this.limit, "min", min);
            this.$set(this.limit, "max", max);
            return this.$util.fmtNum(min) + "元起，最多可投" + this.$util.fmtNum(max) + "元";
        },
        // 获取披露文件信息
        getFileInfo() {
            this.$util.queryReadFileInfo(
                {
                    fundcode: this.fund.fundcode,
                    sharetype: this.fund.sharetype,
                    scene:
                        this.fund.fundcode === this.xjbFundCode
                            ? `${sceneEnum.xjbBuy},${sceneEnum.buy}`
                            : sceneEnum.buy,
                    filetype: "",
                    fundshowtype: this.fund.fundshowtype
                },
                (res) => {
                    res.forEach &&
                        res.forEach((item) => {
                            item.read = false;
                            if (item.filetype.trim() === "7") {
                                // 产品概要
                                this.readFileInfoList.unshift(item);
                            } else {
                                this.readFileInfoList.push(item);
                            }
                        });
                    // 此逻辑只针对公募基金
                    if (this.fund.fundclass == "0") {
                        this.$util.isFundTypeValid(this.fund).then((flag) => {
                            if (!flag) {
                                // 是否有配置产品概要书
                                let obj = this.readFileInfoList.find(
                                    (item) => item.filetype.trim() === "7"
                                );
                                this.hasProductOverview = !obj;
                                if (this.hasProductOverview) {
                                    this.$message.error(
                                        "协议获取失败，暂时无法交易。如有疑问，请联系客服处理。"
                                    );
                                }
                            } else {
                                this.hasProductOverview = false;
                            }
                        });
                    } else {
                        this.hasProductOverview = false;
                    }
                },
                true
            );
        },
        // 获取链接点击事件
        getClick(index) {
            this.currentFileInfoList = [this.readFileInfoList[index]];
            this.readFileInfoList[index].read = true;
            if (this.currentFileInfoList[0].filetype === "7") {
                this.needTime = true;
            } else {
                this.needTime = false;
            }
            this.pdfVisible = true;
        },
        finishReading() {
            this.pdfVisible = false;
            // 如果阅读的是产品概要（filetype === "7"），标记为已完整阅读
            if (this.currentFileInfoList[0] && this.currentFileInfoList[0].filetype === "7") {
                this.hasReadProductOverview = true;
            }
        },
        cancelReading() {
            this.checkbox = false;
            this.pdfVisible = false;
        },
        validatePayWay(rule, value, callback) {
            if (!value) {
                callback(new Error("请选择支付方式"));
            } else {
                callback();
            }

            // 现金宝方式下 limit 由 bankSel 异步接口设置，此处不提前校验，避免拿到错误的 limit
            if (this.fundInfo.way !== "1") {
                this.$nextTick(() => {
                    this.fundInfo.amount && this.$refs.fundInfo.validateField("amount");
                });
            }
        },
        validateCard(rule, value, callback) {
            if (!this.selectedBankid_card) {
                callback(new Error("请选择支付方式"));
            } else {
                callback();
            }
        },
        // 再次购买重置表单
        async reset() {
            this.buySuccess = false;
            // this.bankInfo = {};
            // this.bankLists = []
            // this.allBankList = []
            this.$set(this.fundInfo, "amount", "");
            this.$set(this.fundInfo, "pwd", "");
            this.$set(this.fundInfo, "pay", "");
            this.$set(this.fundInfo, "sharetype", "");
            this.$set(this.fundInfo, "transactionaccountid", "");
            this.$set(this.fundInfo, "paycenterid", "");
            this.selectedQuickSelectName = "";
            // await this.getBuyWay();
        },
        // 处理限额
        amountLimit(rule, value, callback) {
            rule.mes = "购买金额";
            if (this.isXjbBalanceInsufficient) {
                // 仍然抛给 Element Form，让输入框进入错误态；实际展示文案由模板里的自定义提示负责。
                callback(new Error("现金宝可用余额不足，去充值"));
                return;
            }
            // 没选账户，直接提示而不是放过
            if (this.$util.isEmpty(this.fundInfo.transactionaccountid)) {
                callback(new Error("请先选择扣款账户"));
                return;
            }
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        getXjbMinAmount(bankInfo = {}) {
            // 现金宝买基金的起购额同时受三类约束影响：
            // 1. 当前现金宝支付渠道下限 netnominbuy；2. 现金宝配置下限 xjbmin；3. 产品申购最低金额 minamount。
            // 最终取最大值，避免现金宝下限低于产品起购金额时误放过。
            const candidates = [bankInfo.netnominbuy, this.fund.xjbmin, this.fund.minamount]
                .filter((value) => !this.$util.isEmpty(value))
                .map(Number)
                .filter((value) => !isNaN(value));
            return candidates.length ? Math.max(...candidates) : 0;
        },
        getXjbMaxAmount(bankInfo = {}) {
            // 可投上限取现金宝可用余额、渠道单笔上限、现金宝配置上限中的最小有效值。
            const xjbAsset = this.$util.isEmpty(bankInfo.xjbasset)
                ? null
                : Number(bankInfo.xjbasset);
            const limitCandidates = [bankInfo.netnomaxbuy, this.fund.xjbmax]
                .filter((value) => !this.$util.isEmpty(value))
                .map(Number)
                .filter((value) => !isNaN(value) && value > 0);
            const candidates =
                xjbAsset === null || isNaN(xjbAsset)
                    ? limitCandidates
                    : [xjbAsset, ...limitCandidates];
            return candidates.length ? Math.min(...candidates) : 0;
        },
        getVerifyCode(val) {
            this.dialogVisible = false;
            if (val) {
                this.fundInfo.imgCodeVal = val;
                this.$util.getSdxProtocol(this.fund, (res) => {
                    this.fund = res;
                    this.protocol = true;
                });
            }
        },
        // 快速选择
        quickSelect(val) {
            this.$set(this.fundInfo, "amount", val);
            this.selectedQuickSelectName = val;
            this.queryRate();
            this.$nextTick(() => {
                this.$refs.fundInfo.validateField("amount");
            });
        },
        // 处理金额
        isAmount(val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.query = setTimeout(() => {
                this.$set(this.fundInfo, "amount", _val);
                const matched = this.quickSelectList.find(
                    (item) => String(item.name) === String(_val)
                );
                this.selectedQuickSelectName = matched ? matched.name : "";
                this.queryRate();
            }, 1);
        },
        // 费率入参获取
        async queryRate() {
            const querySeq = ++this.queryRateSeq;
            let _d = null;
            const targetSharetype = this.getBuyFeeSharetype();
            if (
                this.fundInfo.amount > 0 &&
                targetSharetype === "0" &&
                this.bankInfo.channelid &&
                this.fund.fundtype !== "2"
            ) {
                if (this.isNormalXjbBuy()) {
                    await this.queryXjbBuyRate(querySeq, targetSharetype);
                    return;
                }
                _d = {
                    fundcode:
                        this.fundInfo.way === "1"
                            ? this.getSelectedXjbFundCode()
                            : this.fund.fundcode,
                    sharetype: targetSharetype,
                    applicationamount: this.fundInfo.amount,
                    applicationvol: "0",
                    paymode:
                        this.fundInfo.way == "2" && this.isagreeeasybuy == "1"
                            ? "1"
                            : this.fundInfo.way,
                    businesscode: this.getBuyBusinessCode(),
                    channelid: this.bankInfo.channelid
                };
                // if (this.fund.comrate) {
                //     _d.comratelist = this.fund.comrate;
                // }
            }
            this.$util.getFee(_d, (res) => {
                if (querySeq === this.queryRateSeq) {
                    this.feeGate = res;
                }
            });
        },
        // Fee helpers
        getBuyBusinessCode() {
            return this.fund.status === "1" ? "20" : "22";
        },
        getBuyFeeSharetype() {
            return this.fund.sharetype === "2" ? this.fundInfo.sharetype : this.fund.sharetype;
        },
        getCachedIsRealtaXjb() {
            const cacheVal =
                sessionStorage.getItem("_isRealtaXjb") || localStorage.getItem("_isRealtaXjb");
            if (cacheVal === null || cacheVal === undefined || cacheVal === "") return null;
            try {
                return JSON.parse(cacheVal) === true;
            } catch (e) {
                return cacheVal === "true";
            }
        },
        isNormalXjbBuy() {
            return this.fundInfo.way === "1" && this.getCachedIsRealtaXjb() === false;
        },
        // 非实时TA现金宝买入：有转换关系按转换业务036，否则按赎回转购业务099。
        async getXjbOfflineBusinessCode() {
            if (this.getCachedIsRealtaXjb() === true) {
                return "";
            }
            try {
                const hasRelation = await this.hasXjbConvertRelation(this.xjbFundCode);
                return hasRelation ? "036" : "099";
            } catch (e) {
                this.$log.error(e);
                return "099";
            }
        },
        // 线下渠道现金宝账号是否可用于当前业务，由杂参26051901控制。
        canUseOfflineXjbAccount(item, businessCode) {
            if (!item || item.banktype !== "1") {
                return true;
            }
            const offlineBusinessCodes = this.$cache.getSysParam("26051901") || "";
            return offlineBusinessCodes.indexOf(businessCode) !== -1;
        },
        getXjbFeeSharetype() {
            const xjbFundInfo = JSON.parse(sessionStorage.getItem("xjbFundInfo")) || {};
            return (
                xjbFundInfo.sharetype || this.xjbSel.sharetype || this.bankInfo.xjbsharetype || "0"
            );
        },
        getSelectedXjbFundCode() {
            const xjbFundInfo = JSON.parse(sessionStorage.getItem("xjbFundInfo")) || {};
            return (
                this.xjbSel.xjbfundcode ||
                this.bankInfo.xjbfundcode ||
                xjbFundInfo.fundcode ||
                this.xjbFundCode
            );
        },
        normalizeTargetFundList(data) {
            if (Array.isArray(data)) return data;
            if (!data || typeof data !== "object") return [];
            if (Array.isArray(data.datalist)) return data.datalist;
            if (data.body && Array.isArray(data.body.datalist)) return data.body.datalist;
            return [];
        },
        getFundCodeFromTargetItem(item) {
            return String(
                item.fundcode ||
                    item.targetfundcode ||
                    item.productcode ||
                    item.prodcode ||
                    item.targetproductcode ||
                    item.targetprodcode ||
                    ""
            ).trim();
        },
        async hasXjbConvertRelation(xjbFundCode) {
            const cacheKey = `${xjbFundCode}_${this.fund.fundcode}`;
            if (Object.prototype.hasOwnProperty.call(this.xjbConvertRelationCache, cacheKey)) {
                return this.xjbConvertRelationCache[cacheKey];
            }
            if (this.xjbConvertRelationPending[cacheKey]) {
                return this.xjbConvertRelationPending[cacheKey];
            }

            const pending = fundApi
                .combQueryTargetFundList({ fundcode: xjbFundCode })
                .then((res) => {
                    const targetList = this.normalizeTargetFundList(res.data);
                    const targetFundCode = String(this.fund.fundcode || "").trim();
                    const hasRelation = targetList.some(
                        (item) => this.getFundCodeFromTargetItem(item) === targetFundCode
                    );
                    this.$set(this.xjbConvertRelationCache, cacheKey, hasRelation);
                    return hasRelation;
                })
                .finally(() => {
                    this.$delete(this.xjbConvertRelationPending, cacheKey);
                });

            this.$set(this.xjbConvertRelationPending, cacheKey, pending);
            return pending;
        },
        buildXjbFeeParams({ fundcode, sharetype, businesscode, targetSharetype }) {
            const params = {
                fundcode,
                sharetype,
                applicationamount: this.fundInfo.amount,
                applicationvol: "0",
                paymode: "1",
                businesscode,
                channelid: this.bankInfo.channelid,
                transactionaccountid: this.bankInfo.transactionaccountid
            };
            if (["24", "36"].includes(businesscode)) {
                params.applicationvol = this.fundInfo.amount;
            }
            if (businesscode === "36") {
                params.targetfundcode = this.fund.fundcode;
                params.targetsharetype = targetSharetype;
            }
            return params;
        },
        getFeeCost(feeGate) {
            if (!feeGate) return 0;
            const cost = !this.$util.isEmpty(feeGate.estimatedcost)
                ? feeGate.estimatedcost
                : feeGate.charge;
            return Number(cost || 0);
        },
        getFeeSaving(feeGate) {
            if (!feeGate) return 0;
            const saving = !this.$util.isEmpty(feeGate.costsavings)
                ? feeGate.costsavings
                : feeGate.discount;
            return Number(saving || 0);
        },
        mergeRedeemForBuyFee(redeemFee, buyFee) {
            return Object.assign({}, buyFee || {}, {
                estimatedcost: this.getFeeCost(redeemFee) + this.getFeeCost(buyFee),
                costsavings: this.getFeeSaving(redeemFee) + this.getFeeSaving(buyFee),
                redeemFeeGate: redeemFee || {},
                buyFeeGate: buyFee || {}
            });
        },
        async queryXjbBuyRate(querySeq, targetSharetype) {
            const xjbFundCode = this.getSelectedXjbFundCode();
            if (!xjbFundCode) {
                this.feeGate = {};
                return;
            }

            const xjbSharetype = this.getXjbFeeSharetype();
            const hasRelation = await this.hasXjbConvertRelation(xjbFundCode);
            if (querySeq !== this.queryRateSeq) return;

            if (hasRelation) {
                const convertRes = await fundApi.qryTransFee(
                    this.buildXjbFeeParams({
                        fundcode: xjbFundCode,
                        sharetype: xjbSharetype,
                        businesscode: "36",
                        targetSharetype
                    })
                );
                if (querySeq === this.queryRateSeq) {
                    this.feeGate = convertRes.data || {};
                }
                return;
            }

            const redeemParams = this.buildXjbFeeParams({
                fundcode: xjbFundCode,
                sharetype: xjbSharetype,
                businesscode: "24",
                targetSharetype
            });
            const buyParams = this.buildXjbFeeParams({
                fundcode: this.fund.fundcode,
                sharetype: targetSharetype,
                businesscode: this.getBuyBusinessCode(),
                targetSharetype
            });
            const redeemRes = await fundApi.qryTransFee(redeemParams);
            const buyRes = await fundApi.qryTransFee(buyParams);
            if (querySeq === this.queryRateSeq) {
                this.feeGate = this.mergeRedeemForBuyFee(redeemRes.data, buyRes.data);
            }
        },
        recAddBank() {
            const _this = this;
            let contentText = "";
            _this.$refs["fundInfo"].validate((valid) => {
                if (valid) {
                    if (_this.fundInfo.way !== "2" || !_this.hasBankRroute) {
                        _this.submitInfo("fundInfo");
                        return;
                    }
                    if (!_this.hasAccount) {
                        _this.$util.getBankInfo(
                            "acct/addbank/banklist",
                            { biztype2: "" },
                            (res) => {
                                if (
                                    res &&
                                    res.length > 0 &&
                                    !_this.$util.isEmpty(_this.recChannelid)
                                ) {
                                    let canAdd = false; // 是否可以新增推荐渠道下的银行卡
                                    for (let i = 0; i < res.length; i++) {
                                        if (_this.recChannelid === res[i].channelid) {
                                            canAdd = true;
                                            _this.recChannelname = _this.$util.getChannelName(
                                                res[i],
                                                {
                                                    channelSubString: true,
                                                    bankSubString: false,
                                                    subNum: 4
                                                }
                                            );
                                            contentText =
                                                "使用" +
                                                _this.recChannelname +
                                                "支付更优惠，请添加" +
                                                _this.recChannelname +
                                                "的银行卡";
                                            _this.$util.showMessageBox(
                                                _this,
                                                "温馨提示",
                                                contentText,
                                                "前往增卡",
                                                "继续交易",
                                                function () {
                                                    delete res[i].child;
                                                    sessionStorage.setItem(
                                                        "recBankInfo",
                                                        JSON.stringify(res[i])
                                                    );
                                                    _this.goAddBank();
                                                },
                                                function () {
                                                    _this.submitInfo("fundInfo");
                                                }
                                            );
                                            return;
                                        }
                                    }
                                    if (!canAdd) {
                                        _this.submitInfo("fundInfo");
                                    }
                                } else {
                                    _this.submitInfo("fundInfo");
                                }
                            }
                        );
                    } else {
                        _this.submitInfo("fundInfo");
                    }
                } else {
                    this.$errorScroll();
                }
            });
        },
        submitInfoBefore() {
            this.$refs["fundInfo"].validate((valid) => {
                if (valid) {
                    if (this.readFileInfoList.length !== 0 && this.fund.fundclass != "1") {
                        // 私募基金需在弹出框中进行签署
                        if (!this.checkbox) {
                            return this.$alert(
                                "根据相关法规要求，请在交易前仔细阅读相关文件，并勾选“我已阅读并同意”选项。",
                                "提示",
                                { confirmButtonText: "确定" }
                            );
                        }
                    }

                    if (
                        !this.checkAgreement &&
                        this.smauthorization != "1" &&
                        this.agreementList.filename
                    ) {
                        return this.$alert(
                            "请在交易前仔细阅读相关文件，并勾选“我已阅读并同意”选项。",
                            "提示",
                            { confirmButtonText: "确定" }
                        );
                    }
                    this.ensureTradeSdxAccess(() => {
                        this.continueSubmitInfoBefore();
                    });
                } else {
                    this.$errorScroll();
                }
            });
        },
        // 处理弹窗确认事件（按钮点击）
        handleDialogConfirm() {
            commonApi.commonLeaveTracesLog(this, {
                eventid: this.$const.RECORD.before_purchasing_verification,
                eventname: `高龄客户购买前校验确定按钮`,
                content: JSON.stringify(
                    Object.assign({
                        name: "高龄客户",
                        dialogContent: this.dialogContent,
                        dialogButtonText: this.dialogButtonText
                    })
                )
            });
            // 根据弹窗类型执行不同操作
            if (this.dialogType === "warn") {
                this.oldercustRiskWarnPassed = true;
                this.buyRiskdialogVisible = false;
                this.confirmDialog = true;
            }
        },
        // 签署完私募电子合同后，点击确认
        privateSubmitBefore(contractno) {
            this.contractno = contractno;
            this.showpwd = true;
            this.priSubmitBtn = true;
        },
        /* 提交表单数据，校验用户信息 */
        async submitInfo(formName) {
            if (this.readFileInfoList.length !== 0 && this.fund.fundclass != "1") {
                if (!this.checkbox) {
                    return this.$alert(
                        "根据相关法规要求，请在交易前仔细阅读相关文件，并勾选“我已阅读并同意”选项。",
                        "提示",
                        { confirmButtonText: "确定" }
                    );
                }
                /* if(this.checkTime){
                    let noRead = [];
                    this.readFileInfoList.forEach(res => {
                        if(res.texttype === "1" && res.read === false){
                            noRead.push("《"+res.textname+"》");
                        }
                    })
                    return this.$alert('请点击链接阅读'+noRead,'提示',{confirmButtonText:'确定'})
                } */
            }
            // 获取留痕申请编号
            try {
                await this.$util.writeFileInfo(
                    {
                        readFileInfoList: this.readFileInfoList,
                        fundcode: this.fund.fundcode,
                        tano: this.fund.tano
                    },
                    (res) => {
                        this.readappno = res;
                    },
                    this
                );
            } catch (e) {
                return;
            }

            this.$children[1].index = 0;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ensureTradeSdxAccess(() => {
                        this.continueSubmitInfo();
                    });
                } else {
                    this.$errorScroll();
                }
            });
        },

        // 获取对应银行卡信息
        async bankSel(val, val2) {
            const _this = this;
            for (const group of this.bankLists) {
                if (group.options && group.options.length > 0) {
                    for (const bank of group.options) {
                        // el-select change 只传 transactionaccountid 一个参数
                        // selectCurCard 传 (channelid, transactionaccountid) 两个参数
                        const matched =
                            val2 !== undefined
                                ? bank.channelid === val && bank.transactionaccountid === val2
                                : bank.transactionaccountid === val;
                        if (matched) {
                            _this.bankInfo = bank;
                            this.fundInfo.pay = bank.channelid;
                            this.fundInfo.transactionaccountid = bank.transactionaccountid;
                            this.fundInfo.paycenterid = bank.paycenterid;
                            // 现金宝方式下 limit 由后续逻辑设置，避免用 undefined 值覆盖
                            if (this.fundInfo.way !== "1") {
                                this.$set(this.limit, "min", bank.netnominbuy);
                                this.$set(this.limit, "max", bank.netnomaxbuy);
                            }
                            break;
                        }
                    }
                }
            }
            if (this.fundInfo.way === "1") {
                // 现金宝申购限额：min 取目标基金渠道起购和现金宝下限的较大值，max 取现金宝可用余额、现金宝上限、渠道上限的较小值
                this.$set(this.limit, "min", this.getXjbMinAmount(this.bankInfo));
                this.$set(this.limit, "max", this.getXjbMaxAmount(this.bankInfo));
            }
            if (this.hasBankRroute && this.fundInfo.way === "2") {
                // 获取智能路由
                this.handleBankRroute();
                return;
            }
            this.queryRate();
            //  补一次 amount 校验（最终 limit 已确定）
            this.$nextTick(() => {
                this.fundInfo.amount && this.$refs.fundInfo.validateField("amount");
            });
        },
        // 获取现金宝信息
        async getBuyWay() {
            this.allBankList = [];
            this.transBankList = [];
            this.bankLists = [];
            this.xjbBankList = [];
            let param = {
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype,
                realtafundcode: this.xjbFundCode
            };
            const res = await fundApi.qryBeforeBuy(param);
            // returnList1-资金来源
            let baseInfo = res.data.returnList1 || {};
            this.fund = Object.assign({}, this.fund, res.data.returnList1, {
                querytype: this.fund.querytype
            });
            const xjbFlag = this.$util.xjbIsOpen();
            if (baseInfo.hkflag === "1") {
                this.fund.payway = `3`;
            }
            this.payway1show =
                this.xjbFundCode != this.fund.fundcode &&
                xjbFlag && // 现金宝开启
                !this.mrfflag;
            if (baseInfo.payflag === "1") {
                // 判断是否有已激活银行卡
                this.fund.payway = `${this.fund.payway},2`;
            }
            this.payway2show = baseInfo.payflag === "1";
            // this.payway3show = baseInfo.hkflag === "1";
            // 汇款支付改为默认显示，根据脚本的openremittancechannel字段区分下单走哪种汇款模式
            this.payway3show = true;
            // returnList2-xjbBankList
            try {
                const isRealtaXjb = this.getCachedIsRealtaXjb() === true;
                const xjbBusinessCode = isRealtaXjb ? "" : await this.getXjbOfflineBusinessCode();
                if (res.data && res.data.returnList2) {
                    res.data.returnList2.forEach((item) => {
                        // 实时TA沿用原柜台卡展示口径；非实时TA按036/099校验线下渠道是否开放。
                        const canUseXjbAccount = isRealtaXjb
                            ? this.$util.showCounterCard() || item.banktype != "1"
                            : this.canUseOfflineXjbAccount(item, xjbBusinessCode);
                        if (
                            item.paycenterid != "1000" &&
                            !this.$util.isEmpty(item.xjbasset) &&
                            Number(item.xjbasset) >= 0 &&
                            canUseXjbAccount &&
                            (item.paycenterid === "0001" || item.authstatus === "1") && // paycenterid为0001时不校验鉴权状态，其它情况需已鉴权才能购买
                            item.ischannelstop === "1" // 屏蔽停用的卡（0-停用，1-正常 空是支付方式停用银行卡）
                        ) {
                            this.xjbBankList.push(item);
                        }
                    });
                }
                const reqRes = await userApi.getMyBankCards();
                if (reqRes.data) {
                    const bankLists = reqRes.data.data.filter((item) => {
                        return (
                            item.authenticateflag === "1" && // 已鉴权才能购买
                            item.ischannelstop === "1" // 屏蔽停用的卡（0-停用，1-正常 空是支付方式停用银行卡）
                        );
                    });

                    // Optimization: Use Map for O(1) lookup
                    const bankMap = new Map();
                    bankLists.forEach((item) => {
                        bankMap.set(item.paycenterid + item.bankcode, item);
                    });

                    this.xjbBankList.forEach((item1) => {
                        item1.netnomaxbuy = "";
                        item1.perdaymax = "";
                        item1.maxlimitsingle = "";

                        // Pre-calculate displayCardNo
                        item1.displayCardNo = this.$util.lastFour([
                            item1.desendepositcard,
                            item1.depositcardproc,
                            item1.depositcard
                        ]);
                        item1.displayLabel =
                            this.$util.getChannelName(item1) + "(" + item1.displayCardNo + ")";

                        const matchedBank = bankMap.get(item1.channelid);
                        if (matchedBank) {
                            item1.netnomaxbuy = matchedBank.maxlimitsingle;
                            item1.perdaymax = matchedBank.perdaymax;
                            item1.maxlimitsingle = matchedBank.maxlimitsingle;
                        }
                    });
                }
            } catch (e) {
                this.$log.error(e);
            }
            // 现金宝账号全部被过滤时，隐藏“现金宝优惠买基金”资金来源。
            this.payway1show = this.payway1show && this.xjbBankList.length > 0;
            // returnList3-allBankList
            this.allBankList = res.data.returnList3.filter((item) => {
                return (
                    item.authstatus === "1" && // 已鉴权才能购买
                    item.ischannelstop === "1" && // 屏蔽停用的卡（0-停用，1-正常 空是支付方式停用银行卡）
                    item.hkflag !== "1"
                );
            });
            this.allBankList.forEach((item) => {
                item.maxlimitsingle = item.netnomaxbuy;
                item.perdaymax = item.netnomaxperday;
                // Pre-calculate displayCardNo
                item.displayCardNo = this.$util.lastFour([
                    item.desendepositcard,
                    item.depositcardproc,
                    item.depositcard
                ]);
                item.displayLabel =
                    this.$util.getChannelName(item) + "(" + item.displayCardNo + ")";
            });

            this.transBankList = res.data.returnList3.filter((item) => {
                return (
                    item.ischannelstop === "1" && // 屏蔽停用的卡（0-停用，1-正常 空是支付方式停用银行卡）
                    item.hkflag == "1"
                );
            });

            this.transBankList.forEach((item) => {
                item.maxlimitsingle = item.netnomaxbuy;
                item.perdaymax = item.netnomaxperday;
                // Pre-calculate displayCardNo
                item.displayCardNo = this.$util.lastFour([
                    item.desendepositcard,
                    item.depositcardproc,
                    item.depositcard
                ]);
                item.displayLabel =
                    this.$util.getChannelName(item) + "(" + item.displayCardNo + ")";
            });
            // 初始化-资金来源，优先默认选理财宝，无理财宝时才默认银行卡
            if (this.payway1show) {
                this.$set(this.fundInfo, "way", "1");
            } else if (this.payway2show) {
                this.$set(this.fundInfo, "way", "2");
            } else if (this.payway3show) {
                this.$set(this.fundInfo, "way", "3");
            } else {
                this.$set(this.fundInfo, "way", "");
            }
            // this.bankListsOfR = res.data.returnList3
        },
        // 切换为银行卡支付时数据初始化
        // getBank (channelid) {
        //     // 获取银行卡信息
        //     const _x = this.bankLists[0] ? this.bankLists[0].options[1].moneyaccount : "";
        //     if (_x) {
        //         this.$set(this.fundInfo, "pay", _x);
        //         this.bankSel(_x);
        //     }
        //     this.pla = this.getLimit(channelid);
        // },
        // 生成确认信息
        resultMes(res) {
            let code = "1";
            if (res.data) {
                code = (res.data.paystatus && res.data.paystatus.trim()) || "1"; // 支付正在处理中返回p
                this.result.cla = "register-success";
                this.result.btnMsg =
                    "预计确认：" +
                    this.$util.fmtDate(this.cfmdate) +
                    "， 如遇节假日则顺延，请耐心等待";
            } else {
                this.result.cla = "register-fail";
                this.result.btnMsg = "原因：" + res.msg;
            }
            /* if (this.fundInfo.way === "3") {
                this.result.transfer = {
                    remitbankbranch: res.data[0].remitbankbranch.split(/[,，]/)[0],
                    remitacctname: res.data[0].remitacctname.split(/[,，]/)[0],
                    remitcardnum: res.data[0].remitcardnum.split(/[,，]/)[0]
                };
            } */
            let state =
                code === "1"
                    ? "已受理" + (this.result.cla === "register-fail" ? "失败" : "成功")
                    : "正在处理中";
            this.result.msg =
                "您的" +
                (this.fundInfo.way === "1" ? "现金宝" : this.fundInfo.way === "2" ? "" : "汇款") +
                "购买申请" +
                state;
            this.buySuccess = true;
        },
        // 校验用户银行卡手机验证码
        checkVerifyCode(val) {
            this.checkMobile = false;
            if (!val) return false;
            const _this = this;
            this.$util.request("trade/buy/paycheckmsg", { verifycode: val }, "POST").then((res) => {
                let _x = {
                    msg: res.msg
                };
                if (res.data) {
                    res.data[0].status = "1";
                    _x.data = [res.data[0]];
                }
                _this.resultMes(_x);
            });
        },
        // 初始化组合定投数据
        initComboData() {
            this.fund.fundCode = "[" + this.fund.fundcode.replace(/,/g, "] [") + "]";
            this.fund.fundName = "[" + this.fund.fundname.replace(/,/g, "] [") + "]";
            const _x = this.fund.comrate.split(",");
            let _y = "";
            for (let i in _x) {
                _y += "[" + _x[i] * 100 + "%] ";
            }
            this.fund.comRate = _y;
        },
        // 双因素认证
        async smsCheck(val) {
            this.protocol = false;
            if (!val) return;
            let smsFlag = false; // 是否需要进行双因素认证
            if (
                this.$util.openSalesGuidance() &&
                this.$cache.getSysParam("10113004") &&
                this.$cache.getSysParam("10113004").indexOf("1") > -1 &&
                this.$cache.getSysParam("10113005") &&
                Number(this.$cache.getSysParam("10113005")) <= Number(this.fundInfo.amount)
            ) {
                smsFlag = true;
            }
            if (smsFlag) {
                const pwdRes = await userApi.combPasswordCheck({
                    tradepassword: this.$util.enc(this.fundInfo.pwd)
                });
                if (pwdRes.code != 0) {
                    return;
                }
                this.smsVisible = true;
            } else {
                this.buyNow(val);
            }
        },
        async buyNow(val) {
            this.protocol = false;
            if (!val) return;
            if (this.readFileInfoList.length > 0 && this.readappno.length === 0) {
                return this.$alert("没有留痕申请编号,操作失败 请联系客服");
            }
            // 募集期最后一天禁止使用现金宝认购
            if (this.fundInfo.way == 1 && this.fund.status === "1" && this.fund.ipoenddate) {
                const today = format(new Date(), "YYYYMMDD");
                const ipoEndDate = this.fund.ipoenddate.substring(0, 8);
                if (today === ipoEndDate) {
                    this.$message.warning(
                        "认购期最后一天暂停现金宝购买功能，请您使用银行卡支付或转账交易进行认购"
                    );
                    return;
                }
            }

            if (this.fundInfo.way == 2 || this.fundInfo.way == 3) {
                if (this.isagreeeasybuy !== "1") {
                    await this.handleNormalBankBuy();
                } else {
                    this.saveMoneyBuy();
                }
            } else {
                let xjbSel = this.xjbBankList.find((item) => {
                    return item.transactionaccountid === this.fundInfo.transactionaccountid;
                });
                if (!xjbSel) return;
                await this.handleXJBBuy();
            }
        },
        async handleNormalBankBuy() {
            try {
                let data = {
                    fundcode: this.fund.fundcode,
                    sharetype:
                        this.fund.sharetype == "2" ? this.fundInfo.sharetype : this.fund.sharetype,
                    paymode: this.fundInfo.way,
                    moneyaccount: this.fundInfo.pay, // 资金账户
                    transactionaccountid: this.fundInfo.transactionaccountid, // 交易账号
                    applicationamount: this.fundInfo.amount, // 申请金额
                    tradepassword: this.$util.enc(this.fundInfo.pwd),
                    paycenterid: this.getCurrentPaycenterid(),
                    readappno: this.readappno,
                    contractno: this.contractno,
                    buyflag: this.fund.riskmismatchflag == "1" ? "1" : "2",
                    riskwarnflag: this.fund.riskwarnflag == "1" ? "1" : "2",
                    highriskwarnflag: this.fund.highriskwarnflag == "1" ? "1" : "2"
                };
                // 中港互认基金增加入参mrffundflag传1
                if (this.mrfflag) {
                    data.mrffundflag = "1";
                }
                this.randomToken = this.$util.generateRandomNumber();
                data.pagecallbackurl =
                    window.location.origin +
                    "" +
                    "/sale-mid-ump/bank/redirect?token=" +
                    this.randomToken;
                // 建行网联的回调地址配置在银行那边，需要单独处理
                if (this.getCurrentPaycenterid() == "0105") {
                    data.pagecallbackurl = window.location.origin + "" + "/sale-mid-ump/bank/ccb";
                }
                // 高龄客户风险警示标识 1-已警示
                if (this.dialogType == "warn") {
                    data.oldercustriskflag = "1";
                }
                if (
                    // 当有此参数值时或者配置了交易账号模式才走原逻辑
                    !this.useOldLogic &&
                    this.fundInfo.way == 3
                ) {
                    data.paymethod = "2";
                }
                const res = await fundApi.fundBuyOrderPay(data);
                if (res.code === "0") {
                    this.processBankPayResult(res);
                } else {
                    this.confirmDialog = false;
                }
                this.cfmdate = res.data ? res.data.transactioncfmdate : "";
            } catch (e) {
                this.$log.error(e);
            }
        },
        processBankPayResult(res) {
            if (res.data.bankurl && res.data.method) {
                this.handleBankPopup(res.data);
            } else {
                this.resultDialogObj = res.data;
                this.confirmDialog = false;

                if (this.fundInfo.way == 3) {
                    // 汇款支付跳转到展示账户信息页面
                    this.$router.push({
                        name: `hkresult`,
                        params: {
                            fundcode: this.fund.fundcode,
                            fundname: this.fund.fundname,
                            amount: this.fundInfo.amount,
                            producttype: this.producttype,
                            sharetype: this.fund.sharetype,
                            transactiondate: res.data.transactiondate,
                            paychannel: this.getResultPayChannel(res.data)
                        }
                    });
                } else {
                    this.resultDialog = true;
                    this.resultDialog = true;
                }
            }
            this.modifySmAuthorization(); // 授权调用（也就是签署） 入参 smauthorization : 1
        },
        handleBankPopup(data) {
            const pageUrl = data.bankurl ? data.bankurl : "";
            let pageParam = data.bankgateparam ? data.bankgateparam : {};
            if (pageParam) {
                try {
                    pageParam = JSON.parse(pageParam);
                } catch (e) {
                    // ignore
                }
            }
            const reqMethod = data.method;
            this.$util.openPostWindow(pageUrl, pageParam, reqMethod, "_blank");
            const params = {
                token: this.randomToken,
                appsheetserialno: data.appsheetserialno,
                bankgateserialno: data.bankgateserialno,
                paycenterid: this.getCurrentPaycenterid()
            };
            this.$util.confirmBankAuth(this, params, "tradePayAuthentication", (payStatus) => {
                this.payStatus = payStatus;
                this.resultDialogObj = data;
                this.confirmDialog = false;
                this.resultDialog = true;
            });
        },
        async handleXJBBuy() {
            try {
                // 现金宝基金信息从缓存获取
                const xjbFundInfo = JSON.parse(sessionStorage.getItem("xjbFundInfo")) || {};
                const data = {
                    // ===== 原有入参保持不变 =====
                    transactionaccountid: this.fundInfo.transactionaccountid,
                    tradepassword: this.$util.enc(this.fundInfo.pwd),
                    applicationvol: this.fundInfo.amount,
                    targetfundcode: this.fund.fundcode, // 目标基金代码（要买的基金）
                    redeemmode: "5",
                    largeredemptionflag: "0",
                    targetsharetype:
                        this.fund.sharetype == "2" ? this.fundInfo.sharetype : this.fund.sharetype, // 目标收费方式（要买的基金）
                    paymethod: "1",
                    buyflag: this.fund.riskmismatchflag == "1" ? "1" : "2",
                    riskwarnflag: this.fund.riskwarnflag == "1" ? "1" : "2",
                    highriskwarnflag: this.fund.highriskwarnflag == "1" ? "1" : "2",
                    // ===== 新接口 combTransXjbBuy 新增入参 =====
                    fundcode: xjbFundInfo.fundcode || "", // 现金宝基金代码
                    sharetype: xjbFundInfo.sharetype || "", // 现金宝收费方式
                    readappno: this.readappno // 信披阅读流水号
                };
                // 高龄客户风险警示标识 1-已警示
                if (this.dialogType == "warn") {
                    data.oldercustriskflag = "1";
                }
                // 中港互认基金增加入参 mrffundflag 传 1
                if (this.mrfflag) {
                    data.mrffundflag = "1";
                }
                const res = await fundApi.combTransXjbBuy(data);
                if (res.data.appsheetserialno) {
                    this.resultDialogObj = {
                        transactioncfmdate: res.data.transactioncfmdate,
                        incomeqrydate: "", // 新接口无返回，置空
                        operdatetime:
                            res.data.operdate && res.data.opertime
                                ? res.data.operdate + res.data.opertime
                                : ""
                    };
                    this.confirmDialog = false;
                    this.resultDialog = true;
                } else {
                    this.confirmDialog = false;
                }
                this.cfmdate = res.data ? res.data.transactioncfmdate : "";
            } catch (e) {
                this.$log.error(e);
            }
        },
        async setCusttag() {
            if (
                this.fundInfo.way == "2" &&
                this.isagreeeasybuy == "1" &&
                (this.info.custtag === "0" || this.$util.isEmpty(this.info.custtag))
            ) {
                this.$util.opCustTag("1", this.info);
            }
        },
        openDialog() {
            if (this.priSubmitBtn) {
                // 私募签署完电子合同后，输入框置灰操作
                return false;
            }
            this.cardsDialog = true;
        },
        handleClose() {
            this.cardsDialog = false;
        },
        confirmSelect(val) {
            console.log(val);
        },
        getCurrentPaycenterid() {
            // 下单 paycenterid 必须跟当前选中卡一致，不能再被汇款渠道规则改写。
            return (this.bankInfo && this.bankInfo.paycenterid) || this.fundInfo.paycenterid || "";
        },
        getCurrentPayChannel() {
            if (this.fundInfo.way != "3") {
                return this.fundInfo.paycenterid;
            }

            // 汇款支付渠道统一由工具方法按 trade_info.openremittancechannel 和 10113006 解析。
            return this.$util.getRemitTradePayChannel();
        },
        getResultPayChannel(data = {}) {
            // 后台未返回 paychannel 时，结果页仍按本次汇款规则查询收款账户。
            return data.paychannel || this.getCurrentPayChannel();
        },
        selectCurCard(item, index) {
            this.curSelectCard = item;
            this.fundInfo.pay = item.channelid;
            this.fundInfo.transactionaccountid = item.transactionaccountid;
            this.bankSel(item.channelid, item.transactionaccountid);
        },
        formatDateTime(dateTimeStr) {
            // 将字符串按照一定的格式解析成年、月、日、时、分的部分
            let year = dateTimeStr.substring(0, 4);
            let month = dateTimeStr.substring(4, 6);
            let day = dateTimeStr.substring(6, 8);
            let hour = dateTimeStr.substring(8, 10);
            let minute = dateTimeStr.substring(10, 12);

            // 使用Date对象构造日期时间
            let dateTime = new Date(`${year}-${month}-${day}T${hour}:${minute}`);

            // 格式化日期时间输出
            let formattedDateTime = `${dateTime.getFullYear()}-${this.addLeadingZero(
                dateTime.getMonth() + 1
            )}-${this.addLeadingZero(dateTime.getDate())} ${this.addLeadingZero(
                dateTime.getHours()
            )}:${this.addLeadingZero(dateTime.getMinutes())}`;

            return formattedDateTime;
        },
        addLeadingZero(number) {
            return number < 10 ? "0" + number : number;
        },
        sucClick() {
            this.resultDialog = false;
            this.$router.push({ name: `traderecord` });
        },
        async saveMoneyBuy() {
            try {
                let data = {
                    fundcode: this.fund.fundcode,
                    sharetype:
                        this.fund.sharetype == "2" ? this.fundInfo.sharetype : this.fund.sharetype,
                    moneyaccount: this.fundInfo.pay, // 资金账户
                    transactionaccountid: this.fundInfo.transactionaccountid, // 交易账号
                    applicationamount: this.fundInfo.amount, // 申请金额
                    tradepassword: this.$util.enc(this.fundInfo.pwd),
                    paycenterid: this.getCurrentPaycenterid(),
                    readappno: this.readappno,
                    buymode: this.fundInfo.way == "3" ? "1" : "0", // 柜台区分0 和 非0,0 充值实时TA再转购
                    relatafundcode: this.xjbFundCode,
                    contractno: this.contractno,
                    buyflag: this.fund.riskmismatchflag == "1" ? "1" : "2",
                    riskwarnflag: this.fund.riskwarnflag == "1" ? "1" : "2",
                    highriskwarnflag: this.fund.highriskwarnflag == "1" ? "1" : "2"
                };

                this.randomToken = this.$util.generateRandomNumber();
                data.pagecallbackurl =
                    window.location.origin +
                    "" +
                    "/sale-mid-ump/bank/redirect?token=" +
                    this.randomToken;
                // 建行网联的回调地址配置在银行那边，需要单独处理
                if (this.getCurrentPaycenterid() == "0105") {
                    data.pagecallbackurl = window.location.origin + "" + "/sale-mid-ump/bank/ccb";
                }
                // 高龄客户风险警示标识 1-已警示
                if (this.dialogType == "warn") {
                    data.oldercustriskflag = "1";
                }
                const res = await fundApi.combTransBuy(data);
                if (res.error) return;
                if (res.data.appsheetserialno) {
                    if (res.data.bankgateurl && res.data.method) {
                        const pageUrl = res.data.bankgateurl ? res.data.bankgateurl : "";
                        let pageParam = res.data.bankgateparam ? res.data.bankgateparam : {};
                        if (pageParam) {
                            pageParam = JSON.parse(pageParam);
                        }
                        const reqMethod = res.data.method;
                        this.$util.openPostWindow(pageUrl, pageParam, reqMethod, "_blank");
                        const params = {
                            token: this.randomToken,
                            appsheetserialno: res.data.appsheetserialno,
                            bankgateserialno: res.data.bankgateserialno,
                            paycenterid: this.getCurrentPaycenterid()
                        };
                        this.$util.confirmBankAuth(
                            this,
                            params,
                            "tradePayAuthentication",
                            (payStatus) => {
                                this.payStatus = payStatus;
                                this.resultDialogObj = {
                                    transactioncfmdate: res.data.transactioncfmdate,
                                    incomeqrydate: res.data.incomedate,
                                    operdatetime: res.data.operdatetime
                                };
                                this.confirmDialog = false;
                                this.resultDialog = true;
                                this.setCusttag();
                            }
                        );
                    } else {
                        this.resultDialogObj = {
                            transactioncfmdate: res.data.transactioncfmdate,
                            incomeqrydate: res.data.incomedate,
                            operdatetime: res.data.operdatetime
                        };
                        this.confirmDialog = false;
                        if (this.fundInfo.way == 3) {
                            // 汇款支付跳转到展示账户信息页面
                            this.$router.push({
                                name: `hkresult`,
                                params: {
                                    fundcode: this.fund.fundcode,
                                    fundname: this.fund.fundname,
                                    amount: this.fundInfo.amount,
                                    producttype: this.producttype,
                                    sharetype: this.fund.sharetype,
                                    transactiondate: res.data.transactiondate,
                                    paychannel: this.getResultPayChannel(res.data)
                                }
                            });
                        } else {
                            this.resultDialog = true;
                        }
                        this.setCusttag();
                    }
                } else {
                    this.confirmDialog = false;
                }
                this.cfmdate = res.data ? res.data.transactioncfmdate : "";
            } catch (e) {
                this.$log.error(e);
            }
        },
        smsClose() {
            this.smsVisible = false;
            this.$refs.protocol.protocol = [];
            this.$refs.protocol.index = 0;
        },
        // 查中港互认基金标识
        async getMrfFlag() {
            const res = await fundApi.getFundLists({
                fundcode: this.fund.fundcode,
                fundclass: this.fund.fundclass,
                pagesize: 100,
                pagenum: 1
            });

            if (res.data && res.data.list && res.data.list.length > 0) {
                const fundData = res.data.list[0];
                if (fundData.ext) {
                    try {
                        const extData = JSON.parse(fundData.ext.replace(/\n/g, "\\n"));
                        const extraItem = extData.find(
                            (item) => item.definition === "附加管理费说明"
                        );
                        if (extraItem) {
                            this.postChargeDescribe = extraItem.content;
                        }

                        const addAdministrationItem = extData.find(
                            (item) => item.definition === "后收费产品费率说明"
                        );
                        if (addAdministrationItem) {
                            this.addAdministration = addAdministrationItem.content;
                        }
                    } catch (error) {
                        console.error("解析失败:", error);
                    }
                }

                this.producttype = fundData.producttype;
                // qryPageProductService 返回的是产品维度信息，minamount 用来补齐现金宝起购额里的“产品申购最低金额”。
                if (!this.$util.isEmpty(fundData.minamount)) {
                    this.$set(this.fund, "minamount", fundData.minamount);
                }
                this.$emit("fund-data", fundData);
                this.mrfflag = fundData.mrfflag == "1";
                this.deadlinetime = this.$util.transactionDatePrompt(fundData);
            }
            if (this.mrfflag) {
                this.isagreeeasybuy = "0";
            }
        },
        // 跳转
        gotoDetail(val) {
            this.$util.toFundDetailPage(val.fundcode);
        },
        async signContract() {
            if (this.fund.fundclass == "1") {
                // 私募基金签署电子合同
                const { data } = await userApi.queryAwaitSignElecontract({
                    fundcode: this.fund.fundcode,
                    custno: this.info.custno
                });
                if (!data || data.length == 0) {
                    this.$message.warning("协议获取失败，暂时无法交易。如有疑问，请联系客服处理");
                } else {
                    this.contractList = data;
                    this.confirmDialog = false;
                    this.signContractdialogVisible = true;
                }
            } else {
                this.submitInfo("fundInfo");
            }
        },
        async qryBusinessFile() {
            const userinfo = await this.$cache.getUser();
            this.smauthorization = userinfo.smauthorization;
            if (this.smauthorization != "1") {
                const res = await fundApi.getProtocol({
                    policytype: "x",
                    fundtype: this.fund.fundshowtype
                });
                if (res.data && res.data.length > 0) {
                    this.agreementList = {
                        filename: res.data[0].title,
                        fileid: res.data[0].fileid
                    };
                }
            }
        },
        openFile(fileCode) {
            window.open(this.$util.fileDownloadPath(fileCode));
        },
        async modifySmAuthorization() {
            if (this.smauthorization != "1") {
                await userApi.modifySmAuthorization({ smauthorization: "1" });
                this.$cache.refreshUser();
            }
        },
        async resetTPwd() {
            if (this.isTradeSmsReset) {
                this.$router.push({ name: "tradepwd" });
                return;
            }
            const reqRes = await userApi.getMyBankCards();
            if (reqRes.data) {
                const bankLists = reqRes.data.data.filter((item) => {
                    return (
                        item.authenticateflag === "1" && // 已鉴权才能购买
                        item.ischannelstop === "1" // 屏蔽停用的卡（0-停用，1-正常 空是支付方式停用银行卡）
                    );
                });

                if (bankLists.length == 0) {
                    this.$message.warning(
                        "为保障您的账户安全，重置交易密码需存在开通线上支付的银行卡"
                    );
                } else {
                    this.$router.push({ name: "tradepwd" });
                }
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.comp-buy {
    padding-bottom: 30px;
    overflow-x: hidden;
    .pwdForm .el-form-item.form-text {
        margin-bottom: 10px;
    }
    .pwdForm .el-form-item.form-nor {
        margin-bottom: 20px;
    }
    .dc-cancel-btn {
        margin-right: 20px;
    }
    .el-button {
        width: 180px;
        height: 42px;
    }
    .el-form-item.payway-list {
        ::v-deep .el-form-item__error.el-form-item__error--inline {
            left: 52%;
        }
    }
}
.quick-select {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
    .quick-chip {
        display: inline-block;
        padding: 3px 10px;
        background: #f6f6f6;
        color: #999;
        border-radius: 3px;
        border: 1px solid #e1e1e1;
        cursor: pointer;
        line-height: 14px;
    }
    .quick-chip.active {
        background: #fcf1f2;
        border-radius: 3px;
        color: #f35549;
        border: 1px solid #e1e1e1;
    }
}
.add-bank-btn {
    position: absolute;
    left: 52%;
    cursor: pointer;
    color: var(--color-redirect);
    &:hover {
        opacity: 0.7;
    }
}
.buy-range {
    color: var(--color-text-accent);
    .upd-pay-edu {
        font-weight: bold;
        text-decoration: underline;
        color: var(--color-text-primary);
        margin-left: 20px;
        cursor: pointer;
    }
}
.xjb-balance-error {
    display: flex;
    align-items: center;
    margin-top: 8px;
    color: var(--color-danger);
    font-size: 12px;
    line-height: 1;
    .el-icon-circle-close {
        margin-right: 8px;
    }
    .link-text {
        margin-left: 4px;
    }
}
.payway-list {
    position: relative;
    .bank-discount {
        float: right;
        margin-left: 8px;
        padding: 1px 8px;
        border-radius: 2px;
        background: #d9a35d;
        color: #fff;
        font-size: 12px;
        line-height: 18px;
    }
    ::v-deep .el-select.has-discount {
        .el-input__inner {
            color: transparent;
        }
    }
    .selected-bank-display {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        display: flex;
        align-items: center;
        width: 420px;
        height: 40px;
        box-sizing: border-box;
        padding: 0 48px 0 15px;
        color: var(--color-text-primary);
        font-size: 14px;
        line-height: 40px;
        pointer-events: none;
    }
    .selected-bank-label {
        flex: 0 1 auto;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .selected-bank-discount {
        flex-shrink: 0;
        float: none;
        margin-left: 8px;
        white-space: nowrap;
    }
    .hot-area {
        width: 420px;
        height: 40px;
        // background-color: #1890ff;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99 !important;
    }
    .no-card-hot-area {
        width: 400px;
        height: 40px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99 !important;
        border: 1px solid var(--color-divided);
        border-radius: 4px;
        box-sizing: border-box;
        padding: 0 15px;
        color: var(--color-text-weak);
        font-size: 14px;
    }
}
.cards-container {
    max-height: 600px;
    overflow-y: auto;
    padding: 40px 20px 0;
    .card-item {
        display: flex;
        width: 100%;
        border-bottom: 1px solid var(--color-divided);
        padding-bottom: 12px;
        margin-bottom: 12px;
        .card-img {
            // display: inline-block;
            width: 30px;
            height: 30px;
            margin-right: 10px;
            position: relative;
            top: 5px;
        }
        .bank-detail {
            flex: 1;
            position: relative;
            .line- {
                color: var(--color-text-accent);
            }
            .line-1 {
                margin-bottom: 6px;
                font-family: Source Han Sans CN;
                font-size: 18px;
                font-weight: normal;
                color: var(--color-text-primary);
            }
            .line-2 {
                font-family: Source Han Sans CN;
                font-size: 14px;
                font-weight: normal;
                color: var(--color-text-accent);
            }
            .el-icon-check {
                color: var(--color-primary);
                font-size: 18px;
                position: absolute;
                top: 20px;
                font-weight: bold;
                right: 5px;
            }
        }
    }
}
.button-container {
    width: 100%;
    text-align: center;
    .btn-confirm {
        color: var(--color-text-white);
        background-color: var(--color-primary);
        width: 150px;
        margin: 30px auto 0;
        padding: 10px 0;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
        &:hover {
            opacity: 0.7;
        }
    }
    .cancel {
        color: var(--color-text-primary);
        background: var(--color-accent);
    }
}
.confirm-btn {
    display: flex;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
    color: var(--color-primary) !important;
}
.upper-amount {
    font-family: Roboto;
    font-size: 16px;
    font-weight: normal;
    color: var(--color-text-primary);
}
.confirm-order-text {
    color: var(--color-text-primary);
    font-family: Source Han Sans CN;
    font-size: 18px;
    font-weight: normal;
    line-height: 32px;
}
.confirm-container {
    width: 92%;
    margin: 0 auto;
    height: auto;
}
::v-deep .el-dialog__header {
    color: var(--color-text-primary);
    background-color: var(--color-divided);
    font-weight: bold;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
    color: var(--color-text-accent) !important;
}
.result-container {
    margin-top: 20px;
    width: 100%;
    background: var(--color-bg-container);
    padding: 36px 0;
    text-align: center;
    img {
        width: 100px;
        // height: 75px;
        // margin-bottom: 24px;
        margin: 0 auto 24px;
        text-align: center;
        object-fit: contain;
    }
    .buy-suc {
        font-family: Source Han Sans CN;
        font-size: 26px;
        font-weight: 500;
        color: var(--color-text-primary);
        margin: 0 auto 24px;
        text-align: center;
    }
    .buy-suc-time {
        font-family: Source Han Sans CN;
        font-size: 18px;
        color: var(--color-text-regular);
        margin: 0 auto;
        text-align: center;
    }
    .buy-suc-tip {
        font-family: Source Han Sans CN;
        font-size: 18px;
        color: var(--color-text-regular);
        margin-top: 12px;
    }
}
.success-time {
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    .time-item {
        flex: 1;
        text-align: center;
        &.single-item {
            flex: 0 0 auto;
            width: 100%;
            .progress-dot {
                max-width: 400px;
                margin-left: auto;
                margin-right: auto;
                .red-line {
                    width: 150px;
                    flex: none;
                }
            }
        }
        .progress-dot {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 12px;
            .red-line {
                flex: 1;
                height: 1px;
                background-color: var(--color-primary);
            }
            .red-circle {
                width: 14px;
                height: 14px;
                border: 1px solid var(--color-primary);
                border-radius: 50%;
                flex-shrink: 0;
            }
        }
        .time-text {
            p:first-child {
                font-size: 18px;
                color: var(--color-text-primary);
                margin-bottom: 10px;
            }
            p {
                color: var(--color-text-accent);
                font-size: 16px;
            }
        }
    }
}
.deadlinetime-content {
    color: var(--color-text-accent);
    width: 550px;
    line-height: 20px;
}
.cursor-pointer {
    cursor: pointer;
}
.color-999 {
    color: #999999;
}
.ml30 {
    margin-left: 30px;
}
.ml-80 {
    margin-left: -80px;
}
.ml-70 {
    margin-left: -70px;
}
.flex-start {
    display: flex;
    align-items: flex-start;
}
.flex-center {
    display: flex;
    align-items: center;
}
.fs14 {
    font-size: 14px;
}
.red-text-pad {
    padding-left: 5px;
    color: red;
}
.link-text {
    color: #1890ff;
    cursor: pointer;
}
.add-bank-pos {
    position: absolute;
    left: 44%;
}
.del-text {
    color: #999999;
    text-decoration: line-through;
}
.red-ml4 {
    color: #f20c00;
    margin-left: 4px;
}
.red-text {
    color: #f20c00;
}
.gray-text {
    color: #999999;
}
.tip-small {
    margin-left: 5px;
    color: #999999;
    font-size: 12px;
}
.mr2 {
    margin-right: 2px;
}

/* 协议勾选框统一样式 */
.protocol-checkbox-group {
    display: flex;
    align-items: flex-start;
    font-size: 14px;

    .protocol-checkbox-label {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        line-height: 40px;

        input[type="checkbox"] {
            width: 18px;
            height: 18px;
            margin: 0;
            cursor: pointer;
        }

        span {
            padding-left: 5px;
            color: red;
        }
    }

    ul {
        margin: 0;
        padding: 0;
        list-style: none;

        li {
            line-height: 40px;

            a {
                color: var(--color-redirect);
                text-decoration: none;
                cursor: pointer;

                &:hover {
                    color: var(--color-primary);
                }
            }
        }
    }
}
</style>
